module.exports = __webpack_public_path__ + "img/limit.005fcb6e.svg";